import { styled } from '@mui/material/styles';
import { Autocomplete, TextField } from '@mui/material';

export const StyledAutocomplete = styled(Autocomplete)<any>(({ theme }) => ({
  minWidth: 200,
  position: 'relative',
  '& .MuiOutlinedInput-root': {
    height: '36px', // Compact height matching other inputs
    borderRadius: theme.shape.borderRadius,
    padding: '0 8px',
    backgroundColor: theme.palette.white.main,
    '& fieldset': {
      borderColor: '#5b8c6f',
      borderWidth: '1px',
      transition: 'border-color 0.2s, box-shadow 0.2s',
    },
    '&:hover fieldset': {
      borderColor: '#5f847d',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#5f847d',
      borderWidth: '1px', // Thinner focus border
    },
  },

  '& .MuiInputBase-input': {
    fontSize: '0.85rem',
    color: theme.palette.text.primary,
    padding: '4px 4px !important',
  },

  '& .MuiAutocomplete-popupIndicator': {
    color: '#5b8c6f',
    '& svg': { fontSize: '18px' }
  },

  '& .MuiAutocomplete-clearIndicator': {
    color: '#5b8c6f',
    '& svg': { fontSize: '18px' }
  }
}));

export const TextFieldStyled = styled(TextField)(({ theme }) => ({
  '& .MuiInputLabel-root': {
    fontSize: '0.8rem',
    color: theme.palette.text.primary,
  },
}));
